<template>
  <pp-col
    v-if="showFilter"
    class="filters-container__item  pt-0"
    :cols="12"
    :sm="desktopColsCount"
  >
    <p
      v-if="showLabel"
      class="filters-container__item__label text-h6 grey--text text--darken-4 mb-2"
    >
      {{ filterInfo.label }}
    </p>

    <component
      :is="filterInfo.filterComponent"
      v-model="filters[filterInfo.name].value"
      v-bind="filterInfo.attrs"
      :items="filterInfo.options"
      :options="filterInfo.options"
      :error-messages="filterInfo.errors"
      :hide-details="hideDetails"
      :disabled="filterInfo.disabled"
      :menu-class="filterInfo.menuContentClass"
      @input="filterChanged(filterInfo.name, $event)"
      @change="filterChanged(filterInfo.name, $event)"
      @blur="trackFilterByName(filterInfo.name)"
    />
  </pp-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FilterItem',
  props: {
    filterInfo: {
      required: true,
      type: Object
    },
    hideDetails: {
      default: 'hide',
      type: String,
      validator: (val) => {
        return ['auto', 'hide'].includes(val)
      }
    },
    showFilterLabel: {
      default: false,
      type: Boolean
    },
    desktopColsCount: {
      default: 3,
      type: Number
    }
  },
  computed: {
    ...mapGetters({
      filters: 'ui/filters'
    }),
    showLabel () {
      return this.showFilterLabel && this.filterInfo.label
    },
    showFilter () {
      return this.filterInfo?.showFilter
    }
  },
  methods: {
    filterChanged (filterName, value = null, trackFilter = false) {
      filterName && this.$emit('filterChanged', {
        filterName,
        value,
        trackFilter
      })
    },
    trackFilterByName (filterName) {
      filterName && this.$emit('trackFilterByName', filterName)
    }
  }
}
</script>
<style lang="scss" scoped>
.patient-type-toggle {
  flex: 1;
}
</style>
